export default function capitalizeFirstLetter(string) {
  if (typeof string !== 'string') return 'GIVE ME A STRING';
  return `${string?.slice(0, 1).toUpperCase()}${string?.slice(1)}`;
}
